"use client";

import BlogPreviewIframe from "@/app/components/BlogPreviewIframe";
import CmsTemplateLayout from "@/app/campaigns/components/CmsTemplateLayout";

export {
  blogLivePreviewStorageKey,
  cacheBlogLivePreview,
  type BlogLivePreviewCache,
} from "@/app/lib/blogPreviewCache";

type BlogLivePreviewFrameProps = {
  blogId: string;
  campaignId?: string;
  supplierId?: string;
  title?: string;
  version?: number;
  /** When provided, renders via CmsTemplateLayout instead of iframe */
  cmsTemplateJson?: unknown;
};

/** Live blog page — renders via CmsTemplateLayout when cmsTemplateJson is available,
 *  falls back to iframe+Python renderer otherwise. */
export default function BlogLivePreviewFrame({
  blogId,
  campaignId,
  supplierId,
  title,
  version,
  cmsTemplateJson,
}: BlogLivePreviewFrameProps) {
  if (cmsTemplateJson && typeof cmsTemplateJson === "object") {
    return (
      <main className="w-full min-h-screen bg-white">
        <article className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
          {title && (
            <h1 className="text-3xl font-bold mb-8 text-slate-900 leading-tight">
              {title}
            </h1>
          )}
          <CmsTemplateLayout
            data={cmsTemplateJson as Record<string, unknown>}
            editable={false}
          />
        </article>
      </main>
    );
  }

  // Fallback to iframe for blogs without cmsTemplateJson (legacy or failed fetch).
  // page.tsx guarantees campaignId is present when cmsTemplateJson is absent.
  if (!campaignId) return null;
  return (
    <main className="w-full bg-white">
      <BlogPreviewIframe
        campaignId={campaignId}
        blogId={blogId}
        supplierId={supplierId}
        title={title}
        version={version}
        className="block w-full border-0 bg-white"
        style={{ height: "calc(100dvh - 4.5rem)", minHeight: "480px" }}
      />
    </main>
  );
}
